import Litepicker from "litepicker";
import Helper from "../Helper";
import DatePickerToggle from "./DatePickerToggle";

Intl.PluralRules.prototype.select = function(value) {
    if (value === 0) {
        return 'zero';
    }
    if (value === 1) {
        return 'one';
    }
    if (value === 2) {
        return 'two';
    }
    if (value === 3) {
        return 'few';
    }
    if (value === 4) {
        return 'many';
    }

    return 'other';
};


/**
 * This class represent stay range datepicker.
 */
export default class RangeDatePicker {
    /**
     * Constructor.
     *
     * @param {Element} rootElement
     * @param {Search} context on dates selection
     */
    constructor(rootElement, context)
    {
        this.rootElement = $(rootElement);
        this.context = context;
        this.initWidth = $(window).width();

        this.monthsNames = Helper.parseJSON(
            this.rootElement.data("monthsTranslations").replaceAll("'", '"')
        );
        this.daysNames = Helper.parseJSON(
            this.rootElement.data("daysTranslations").replaceAll("'", '"')
        );

        this.startToggle = new DatePickerToggle(
            this.rootElement.find("[data-datepicker-start]"),
            "start",
            this
        );
        this.endToggle = new DatePickerToggle(
            this.rootElement.find("[data-datepicker-end]"),
            "end",
            this
        );
        this.open = false;
        this.datepicker = undefined;
        this.initStartDate = undefined;
        this.initEndDate = undefined;
        this.numberOfLoadedMonths = Helper.isBigMobileOrLower() ? 3 : 2;
        this.defaultFlowStep = "auto";
        this.flowStep = this.defaultFlowStep;
        this.firstSelectedTimestamp = undefined; // Here is being stored timestamp
        this.doubleClickedDay = false;

        this.mobileLoadMoreTranslation = $(rootElement).data(
            "moreDatesTranslation"
        );
        this.mobileLoadLessTranslation = $(rootElement).data(
            "previousDatesTranslation"
        );
        this.clearDatesTranslation = $(rootElement).data("clearDatesTranslation");
        this.closeTranslation = $(rootElement).data("closeTranslation");

        this.canShow = false; // So that only toggles can show datepicker
        this.isReRendering = false;
        this.moreLoadedPrevTime = undefined;
        this.firstMonth = undefined;
        this.preRenderScrollTop = 0;

        /** Variables for render */
        this.firstSelectedDayClass = "";
        this.$ui = undefined;
    }

    /**
     * This function will initialize the datepicker.
     */
    initDatepicker()
    {
        this.startToggle.initClick();
        this.endToggle.initClick();

        this.datepicker = new Litepicker({
            element: this.startToggle.root.get(0),
            elementEnd: this.endToggle.root.get(0),
            numberOfColumns: this.numberOfLoadedMonths,
            numberOfMonths: this.numberOfLoadedMonths,
            allowRepick: false,
            // must have the same z-index as the modal wrapper
            zIndex: 1007,
            singleMode: false,
            format: "DD-MM-YYYY", // For setting dates froms string
            position: "bottom",
            minDate: this.rootElement.data("today"),
            lang: this.rootElement.data("lang"),
            tooltipText: {
                zero: this.rootElement.data("tooltipZero"),
                one: this.rootElement.data("tooltipOne"),
                two: this.rootElement.data("tooltipTwo"),
                few: this.rootElement.data("tooltipThree"),
                many: this.rootElement.data("tooltipFour"),
                other: this.rootElement.data("tooltipFive"),
            },
            buttonText: Helper.parseJSON(this.rootElement.data("buttonValues")),
            tooltipNumber: (totalDays) => {
                return totalDays - 1;
            },
            setup: (picker) => {
                /**
                 * For initial settings after datepicker is initialised
                 */
                picker.on("before:show", (el) => {
                    this.setNumberOfLoadedMonths(this.getInitialNumberOfMonths());
                    this.$ui = $(this.datepicker.ui);

                    // If datepicker have set the range, set init date range
                    if (this.hasSetRange()) {
                        this.initStartDate = this.datepicker.getStartDate();
                        this.initEndDate = this.datepicker.getEndDate();
                    }
                });

                /**
                 * Allow selection of same start/end date and maintain correct selection flow
                 */
                picker.on("before:click", (target) => {
                    picker.preventClick = false;
                    let $target = $(target);
                    // If the click is not on the day or locked day
                    if (
                        $target.closest(".day-item").length <= 0 ||
                        $target.closest(".is-locked").length > 0
                    ) {
                        return;
                    }

                    let timestamp = this.parseDayTimestampFromDay($target);
                    if (this.canBeDateRangeAltered(timestamp)) {
                        this.alterDateRange(timestamp);
                        picker.preventClick = true;
                        return;
                    }

                    /**
                     * Prevent clicking same day when having selected first day already
                     */
                    if (this.isSameDayAsStored(timestamp) && !this.doubleClickedDay) {
                        picker.preventClick = true;
                        return;
                    } else {
                        this.doubleClickedDay = false;
                    }

                    /** Correct click before alternation */
                    this.updateTogglesValues(timestamp);
                    this.firstSelectedDayClass = "prefer-" + this.flowStep;
                    /** Correct click before alternation END */

                    /**
                     * ! After this line, the flow is alternated, that means if we clicked start, after this, the flow will be end
                     */
                    this.alternateFlow();

                    // Allow selection of same start/end date.
                    if ($target.parent().hasClass("day-item")) {
                        let day = $target.parent();

                        // If the range selection event is not triggered yet
                        if (day.filter(".is-start-date.is-end-date").length <= 0) {
                            day.html("" + parseInt($target.text()));

                            if ($(".litepicker:visible").length > 0) {
                                this.clearFirstSelection();
                                this.storeFirstSelection(timestamp);
                                this.doubleClickedDay = true;

                                day.click();
                                return;
                            }
                        }
                    }

                    this.storeFirstSelection(timestamp);
                    this.correctFlow(timestamp);
                });

                /**
                 * Adding footer when rendering the datepicker.
                 */
                picker.on("render", (ui) => {
                    let $ui = $(ui);
                    let container = $(ui)
                        .children()
                        .first();

                    /** Rendering footer */
                    container.append(
                        '<div class="container__actions" data-datepicker-actions></div>'
                    );

                    let actionsWrapper = container.find("[data-datepicker-actions]");
                    actionsWrapper.append(
                        '<a href="javascript:void(0)" class="btn btn-custom-blue clean btn-height-44 mr-15 p-15 weight-medium" data-datepicker-clear>' +
                            this.clearDatesTranslation +
                            "</a>"
                    );
                    actionsWrapper.append(
                        '<a href="javascript:void(0)" class="btn btn-default clean btn-height-44 weight-medium" data-datepicker-close>' +
                            this.closeTranslation +
                            "</a>"
                    );

                    actionsWrapper.find("[data-datepicker-clear]").click(() => {
                        this.clearSelection();
                    });
                    actionsWrapper.find("[data-datepicker-close]").click(() => {
                        this.isReRendering = false;
                        picker.hide();
                    });
                    /** Rendering footer END */

                    let startDateNumber = $ui.find(".day-item.is-start-date").html();
                    $ui.find(".day-item.is-start-date")
                        .html("<div></div><span>" + startDateNumber + "</span>");
                    let endDateNumber = $ui.find(".day-item.is-end-date").html();
                    $ui.find(".day-item.is-end-date")
                        .html("<div></div><span>" + endDateNumber + "</span>");

                    // Append today tooltip to today day
                    $ui.find(".day-item.is-today")
                        .append(
                            '<div class="custom-tooltip">' +
                                this.rootElement.data("todayTranslation") +
                                "</div>"
                        );

                    /** Respo Handling */
                    if (Helper.isBigMobileOrLower() && this.datepicker) {
                        let $monthsContainer = $ui.find(".container__months");
                        let isOnlyFirstDay =
                            ($ui.find(".is-start-date").length > 0 &&
                                $ui.find(".is-end-date").length <= 0) ||
                            $ui.find(".is-start-date.is-end-date").length;

                        // Loading more months on mobile
                        $monthsContainer.append(
                            '<a href="javascript:void(0)" class="clean btn btn-default btn-height-40 btn-bordered--default weight-medium" data-loadmore>' +
                                this.mobileLoadMoreTranslation +
                                "</a>"
                        );
                        $monthsContainer.find("[data-loadmore]").click(() => {
                            let prevDateTime = $monthsContainer
                                .find("[data-loadmore]")
                                .prev()
                                .find("[data-time]")
                                .data("time");
                            this.loadMoreMonths(3, false, prevDateTime);
                            });
                        let currentDate = new Date();
                        let currentMonth = currentDate.getMonth() + 1;
                        let currentYear = currentDate.getFullYear();
                        let firstLoadedDate = new Date(
                            $monthsContainer
                                .find(".day-item")
                                .first()
                                .data("time")
                        );
                        let firstLoadedMonth = firstLoadedDate.getMonth() + 1;
                        let firstLoadedYear = firstLoadedDate.getFullYear();

                        if (
                            firstLoadedMonth > currentMonth ||
                            currentYear < firstLoadedYear
                        ) {
                            // If true set date is not in current month, so there has to be way to load previous months
                            $monthsContainer.prepend(
                                '<a href="javascript:void(0)" class="clean mb-16 btn btn-default btn-height-40 btn-bordered--default weight-medium" data-loadless>' +
                                    this.mobileLoadLessTranslation +
                                    "</a>"
                            );
                            $monthsContainer.find("[data-loadless]").click(() => {
                                let nextDateTime = $monthsContainer
                                    .find("[data-loadless]")
                                    .next()
                                    .find("[data-time]")
                                    .data("time");
                                this.loadMoreMonths(3, true, nextDateTime);
                                });
                        }

                        // If is mobile and has set start date, scroll to it, so user can set end date right away
                        if (isOnlyFirstDay) {
                            $monthsContainer.animate(
                                {
                                    scrollTop: this.preRenderScrollTop,
                                },
                                0
                            );
                            $ui.find(".is-start-date").addClass("is-end-date"); // To make start date same on mobile and laptop
                            this.preRenderScrollTop = 0;
                        }

                        // If the load more months was pressed before
                        if (this.moreLoadedPrevTime) {
                            let $previousMonth = $monthsContainer
                                .find('[data-time="' + this.moreLoadedPrevTime + '"]')
                                .closest(".month-item");
                            $monthsContainer.animate(
                                {
                                    scrollTop:
                                        $monthsContainer.scrollTop() +
                                        ($previousMonth.offset().top -
                                            $monthsContainer.offset().top),
                                },
                                0
                            );
                            this.moreLoadedPrevTime = undefined;
                        }
                    }
                    /** Respo Handling END */

                    this.isReRendering = false;
                });

                /**
                 * Centering the datepicker on show.
                 */
                picker.on("show", (el) => {
                    this.open = true;
                    if (!this.canShow) {
                        this.datepicker.hide();
                        return;
                    }

                    let $ui = $(picker.ui);
                    this.resize($ui);

                    this.canShow = false;

                    if (this.context.autocomplete !== undefined) {
                        this.context.autocomplete.closeResults();
                    }
                });

                /**
                 * On hiding the datepicker save dates to session.
                 */
                picker.on("hide", () => {
                    this.open = false;
                    // If datepicker has not set date range but the init date range is set (user probably quit the datepicker with unfinished selection)
                    if (!this.hasSetRange() && this.hasSetInitRange()) {
                        this.setDateRange(this.initStartDate, this.initEndDate);
                    }

                    this.storeDateRangeToSession();

                    this.updateTogglesValues();
                    this.startToggle.deactivate();
                    this.endToggle.deactivate();

                    this.clearFirstSelection();
                    this.setFlowStep(this.defaultFlowStep);

                    this.context.update();
                    this.context.updateOtherSearches();

                    /**
                     * Fire only if the datepicker is not re-rendering
                     */
                    if (!this.isReRendering) {
                        this.setNumberOfLoadedMonths(2);
                        this.datepicker.calendars = this.datepicker.calendars.slice(0, 1);
                        this.context.hideRespoModal();

                        if (this.datepicker.getStartDate()) {
                            this.firstMonth = this.datepicker.getStartDate();
                        } else {
                            this.firstMonth = this.datepicker.calendars[0].dateInstance;
                        }
                    }

                    if (Helper.isBigMobileOrLower()) {
                        $('html').css({'overflow-y': 'unset'})
                    }
                });

                /**
                 * After dates selection, show them and store them.
                 */
                picker.on("selected", (start, end) => {
                    this.initStartDate = start;
                    this.initEndDate = end;
                    this.startToggle.showDate(this.formatDate(start));
                    this.endToggle.showDate(this.formatDate(end));
                    this.context.update();

                    window.urlClass.addOrReplaceActiveParam({
                        searchstartdate: this.formatDateForStoring(start),
                        searchenddate: this.formatDateForStoring(end),
                    });
                });

                /**
                 * Triggered on day hover.
                 */
                picker.on("tooltip", (tooltip, day) => {
                    let $day = $(day);
                    let hoveredTimeStamp = this.parseDayTimestampFromDay(day);

                    // If hovered day is not matching the flow
                    if (!this.isDayMatchingFlow(hoveredTimeStamp)) {
                        let $ui = $(picker.ui);
                        $(tooltip).css("visibility", "hidden");
                        $ui.find(".is-in-range").removeClass("is-in-range");
                        $ui
                            .find(".is-start-date, .is-end-date")
                            .addClass("is-not-matching");
                    } else {
                        if ($day.hasClass("is-flipped")) {
                            $day.next().addClass("is-before-start");
                        } else {
                            $day.prev().addClass("is-before-end");
                        }
                    }
                });

                /**
                 * On rendering eachh day
                 */
                picker.on("render:day", (day, date) => {
                    if (this.datepicker) {
                        let $day = $(day);

                        // For hover over start date (to decide if show start date style or end date style)
                        if ($day.hasClass("is-start-date")) {
                            $day.addClass(this.firstSelectedDayClass);
                        }
                    }
                });
            },
        });

        /**
         * Initialize datepicker toggles
         */
        this.startToggle.init(this.datepicker.setStartDate.bind(this.datepicker));
        this.endToggle.init(this.datepicker.setEndDate.bind(this.datepicker));

        if (this.rootElement.is("[data-additional-classes]")) {
            $(this.datepicker.ui).addClass(
                this.rootElement.data("additionalClasses")
            );
        }

        /**
         * Registering observers
         */
        window.windowResizeObserve.register(this.windowResizeCallback.bind(this));

        // Scroll event - keep calendar on the same position on desktop
        $(window).on('scroll', () => {
            if (this.open && !$(this.datepicker.ui).hasClass("litepicker--small") && !Helper.isTabletOrLower()) {
                let top = this.rootElement.innerHeight() - 25 - $(window).scrollTop();

                $(this.datepicker.ui).css({
                    top: top + 'px'
                })
            }
        })
    }

    /**
     * This function will clear datepicker's selection and visible values.
     *
     * @param {Boolean} deactivateToggles if all toggles should be deactivated
     */
    clearSelection(deactivateToggles = false)
    {
        this.datepicker.clearSelection();
        this.initStartDate = undefined;
        this.initEndDate = undefined;
        this.storeDateRangeToSession();
        window.urlClass.deleteActiveParams(["searchstartdate", "searchenddate"]);
        this.startToggle.clear();
        this.endToggle.clear();
        if (deactivateToggles) {
            this.startToggle.deactivate();
        } else {
            this.startToggle.activate();
        }
        this.endToggle.deactivate();
        this.clearFirstSelection();
        this.isReRendering = true;
        this.firstSelectedDayClass = "";
    }

    /**
     * This function will reset datepicker to a state where the user can choose dates again.
     *
     * @param {Number} startingDayTimestamp
     */
    refreshSelection(startingDayTimestamp)
    {
        // If starting day is sent, then set flow to selecting end right away
        if (startingDayTimestamp) {
            this.storePreRenderScrollTop();
            this.datepicker.clearSelection();
            this.firstSelectedTimestamp = startingDayTimestamp;
            this.startToggle.showDate(
                this.formatDate(new Date(startingDayTimestamp))
            );
            this.endToggle.clear();
            this.startToggle.deactivate();
            this.endToggle.activate();
            this.firstSelectedDayClass = "prefer-start";
        } else {
            this.datepicker.clearSelection();
            this.clearFirstSelection();
            this.startToggle.activate();
            this.endToggle.deactivate();
        }
    }

    /**
     * This function will clear the days columns from unnecessary structures.
     */
    clearStructure()
    {
        $(this.datepicker.ui)
            .find(".container__days .day-item > div")
            .each((index, element) => {
                let day = $(element).parent();
                day.html(parseInt(day.text()));
            });
    }

    /**
     * This function will store datepicker's date range to session.
     *
     * @param {Function} callback that will be called after new dates were stored to a session
     */
    storeDateRangeToSession(callback = undefined)
    {
        let data = {
            searchstartdate: this.formatDateForStoring(
                this.datepicker.getStartDate()
            ),
            searchenddate: this.formatDateForStoring(this.datepicker.getEndDate()),
            _token: $('meta[name="csrf-token"]').attr("content"),
        };

        $.ajax({
            url: window.origin + "/change-search-record",
            method: "POST",
            data: data,
            success: (returnData) => {
                if (callback !== undefined) {
                    callback();
                }
            },
        });
    }

    /**
     * This funtion will set new date range to datepicker.
     *
     * @param {String} from in format DD-MM-YYYY
     * @param {String} to in format DD-MM-YYYY
     * @param {Function} callback that will be called after new dates were stored to a session
     */
    setDateRange(from, to, callback = undefined)
    {
        this.datepicker.setDateRange(from, to);
        this.storeDateRangeToSession(callback);
    }

    /**
     * Clones date range from another Litepicker.
     *
     * @param {Litepicker} sourceDatepicker
     */
    cloneDateRange(sourceDatepicker)
    {
        if (sourceDatepicker) {
            // If has set date range
            if (
                sourceDatepicker.getStartDate() != null &&
                sourceDatepicker.getEndDate() != null
            ) {
                this.setDateRange(
                    sourceDatepicker.getStartDate(),
                    sourceDatepicker.getEndDate()
                );
                this.updateTogglesValues();
            } else {
                this.clearSelection(true);
            }
            this.context.update();
        }
    }

    /**
     * This function stores the pre-render scroll top
     * * Pre-render scrolltop says, where should datepicker scroll after render (on mobile devices)
     */
    storePreRenderScrollTop()
    {
        this.preRenderScrollTop = $(this.datepicker.ui)
            .find(".container__months")
            .scrollTop();
    }

    /**
     * This function will temporarily
     *
     * @param {Number} timestamp
     */
    storeFirstSelection(timestamp)
    {
        if (!this.firstSelectedTimestamp) {
            this.firstSelectedTimestamp = timestamp;
            this.storePreRenderScrollTop();
        }
    }

    /**
     * This function will clear temporarily stored first selcted day.
     */
    clearFirstSelection()
    {
        this.firstSelectedTimestamp = undefined;
        this.preRenderScrollTop = 0;
    }

    /**
     * This function will update datepicker's toggles with currently selected dates (can be only one selected)
     *
     * @param {Number} clickedTimestamp
     */
    updateTogglesValues(clickedTimestamp = undefined)
    {
        if (clickedTimestamp === undefined) {
            this.startToggle.showDate(
                this.formatDate(this.datepicker.getStartDate())
            );
            this.endToggle.showDate(this.formatDate(this.datepicker.getEndDate()));
        } else {
            let formattedDate = this.formatDate(new Date(clickedTimestamp));

            switch (this.flowStep) {
                case "start": {
                    this.endToggle.clear();
                    this.startToggle.showDate(formattedDate);
                    break;
                }
                case "end": {
                    this.startToggle.clear();
                    this.endToggle.showDate(formattedDate);
                    break;
                }
            }
        }
    }

    /**
     * Returns true if clicked date can be used to alter date range.
     * For example, if we have set range and clicked day in correct flow.
     *
     * @param {Number} clickedTimestamp
     *
     * @returns {boolean}
     */
    canBeDateRangeAltered(clickedTimestamp)
    {
        let matching = false;

        if (this.hasSetRange() && !this.firstSelectedTimestamp) {
            switch (this.flowStep) {
                case "start": {
                    matching = this.datepicker.getEndDate().getTime() > clickedTimestamp;
                    break;
                }
                case "end": {
                    matching =
                        this.datepicker.getStartDate().getTime() < clickedTimestamp;
                    break;
                }
            }
        }

        return matching;
    }

    /**
     * This function will alter date range based on current flow with given day.
     *
     * ! Before this function, the canBeDateRangeAltered() should be checked
     *
     * @param {Number} clickedTimestamp
     */
    alterDateRange(clickedTimestamp)
    {
        switch (this.flowStep) {
            case "start": {
                this.datepicker.setDateRange(
                    clickedTimestamp,
                    this.datepicker.getEndDate()
                );
                this.reRenderDatepicker();
                this.startToggle.activate();
                this.alternateFlow();
                break;
            }
            case "end": {
                this.datepicker.setDateRange(
                    this.datepicker.getStartDate(),
                    clickedTimestamp
                );
                this.reRenderDatepicker();
                this.endToggle.activate();
                this.datepicker.hide();
                break;
            }
        }
    }

    /**
     * This function will correct date selection flow.
     * * Should be called when cliking on datepicker's day.
     *
     * @param {Number} clickedTimestamp
     */
    correctFlow(clickedTimestamp)
    {
        // If is number
        if (!isNaN(clickedTimestamp)) {
            /**
             * If clicked day is not same as the stored one and is set first selection and th day is not matching flow
             * OR
             * If clicked day is not matching the flow and the date range is set
             */
            if (
                (!this.isSameDayAsStored(clickedTimestamp) &&
                    !this.isDayMatchingFlow(clickedTimestamp)) ||
                (!this.isDayMatchingFlow(clickedTimestamp) && this.hasSetRange())
            ) {
                // If true, then the selection not matches the flow
                this.refreshSelection(clickedTimestamp);
            }
        }
    }

    /**
     * This function will tell you if given day time is matching current flow.
     *
     * @param {Number} dayTimeStamp
     * @param {boolean} ignoreSameDay if is same day as stored one check should be done (true = yes)
     *
     * @returns {boolean}
     */
    isDayMatchingFlow(dayTimeStamp, ignoreSameDay = false)
    {
        let matching = true;

        if (this.firstSelectedTimestamp) {
            if (!ignoreSameDay && this.isSameDayAsStored(dayTimeStamp)) {
                return false;
            }

            switch (this.flowStep) {
                case "start": {
                    matching = this.firstSelectedTimestamp > dayTimeStamp;
                    break;
                }
                case "end": {
                    matching = this.firstSelectedTimestamp < dayTimeStamp;
                    break;
                }
            }
        }

        return matching;
    }

    /**
     * This function will change current date selection flow step to other one.
     */
    alternateFlow(force = false)
    {
        if (!this.firstSelectedTimestamp || force) {
            switch (this.flowStep) {
                case "start": {
                    this.startToggle.deactivate();
                    this.endToggle.activate();
                    break;
                }
                case "end": {
                    this.endToggle.deactivate();
                    this.startToggle.activate();
                    break;
                }
            }
        }
    }

    /**
     * This function will step current dates selecting flow step.
     *
     * @param {String} flowContext
     */
    setFlowStep(flowContext)
    {
        this.flowStep = flowContext;

        switch (this.flowStep) {
            case "start": {
                this.endToggle.deactivate();
                break;
            }
            case "end": {
                this.startToggle.deactivate();
                break;
            }
        }
    }

    /**
     * This function will return given date in readable string in format "Mo, 14 May 21".
     *
     * @param {Date} date
     *
     * @return {String}
     */
    formatDate(date)
    {
        let dateString = "";

        if (date != null) {
            dateString =
                this.daysNames[date.getDay() == 0 ? 6 : date.getDay() - 1] + ", ";

            if (date.getDate() >= 10) {
                dateString += date.getDate();
            } else {
                dateString += "0" + date.getDate();
            }

            dateString += " " + this.monthsNames[date.getMonth()] + " ";
            let yearString = "" + date.getFullYear();
            dateString += yearString.substr(yearString.length - 2);
        }

        return dateString;
    }

    /**
     * This function will return currently selected date range in string "start date - end date".
     * Dates are in format "Mo, 14 May 21".
     *
     * @returns {String}
     */
    getFormattedRange()
    {
        let startDate = this.formatDate(this.datepicker.getStartDate());
        let endDate = this.formatDate(this.datepicker.getEndDate());

        return startDate !== "" && endDate !== "" ? startDate + " - " + endDate : "";
    }

    /**
     * This function will return given date in format for storing to database ("DD-MM-YYYY").
     *
     * @param {Date} date
     *
     * @return {String}
     */
    formatDateForStoring(date)
    {
        let dateString = "";

        if (date != null) {
            if (date.getDate() >= 10) {
                dateString += date.getDate();
            } else {
                dateString += "0" + date.getDate();
            }
            dateString += "-";

            if (date.getMonth() + 1 >= 10) {
                dateString += date.getMonth() + 1;
            } else {
                dateString += "0" + (date.getMonth() + 1);
            }
            dateString += "-";
            dateString += date.getFullYear();
        }

        return dateString;
    }

    /**
     * This function will parse day time from datepicker day.
     *
     * @param {Element} day
     *
     * @returns {Number}
     */
    parseDayTimestampFromDay(day)
    {
        return parseInt(
            $(day)
                .closest("[data-time]")
                .data("time")
        );
    }

    /**
     * This function will return true if given daytime is same as the stored one.
     *
     * @param {Number} daytime
     *
     * @returns {boolean}
     */
    isSameDayAsStored(daytime)
    {
        return this.firstSelectedTimestamp === daytime;
    }

    /**
     * This function re-renders the datepicker.
     */
    reRenderDatepicker()
    {
        this.datepicker.render();
    }

    /**
     * Returns true if the datepicker has set init range.
     * * Init range is range with dates that were set in datepicker when it opened
     *
     * @returns {boolean}
     */
    hasSetInitRange()
    {
        return this.initStartDate !== undefined && this.initEndDate !== undefined;
    }

    /**
     * Returns true if the datepicker has set range.
     *
     * @returns {boolean}
     */
    hasSetRange()
    {
        return (
            this.datepicker.getStartDate() != null &&
            this.datepicker.getEndDate() != null
        );
    }

    /**
     * If the datepicker can be toggled.
     *
     * @returns {boolean}
     */
    canToggle()
    {
        return this.context.canToggleAction();
    }

    /**
     * Opens search respo modal.
     *
     * @param {Number} index (0 - start, 1 - end)
     */
    openSearchRespoModal(index = 0)
    {
        this.context.openRespoModal(
            [this.startToggle.root, this.endToggle.root],
            index
        );
    }

    /**
     * This function will return initial number of months.
     * * On respo it can change but in laptop view the number will always be 2
     *
     * @returns {Number}
     */
    getInitialNumberOfMonths()
    {
        let count = Helper.isBigMobileOrLower() ? 3 : 2;

        // If is mobile view and has set date range
        if (
            Helper.isBigMobileOrLower() &&
            this.getFormattedRange() != "" &&
            this.datepicker != undefined
        ) {
            let startDate = this.datepicker.getStartDate();
            let endDate = this.datepicker.getEndDate();

            count = (startDate.getFullYear() - endDate.getFullYear()) * 12;
            count -= endDate.getMonth();
            count += startDate.getMonth();
            count = Math.abs(count) + 1;
            count = count < 3 ? 3 : count;
        } else {
            count = Helper.isBigMobileOrLower() ? 3 : 2;
        }

        return count;
    }

    /**
     * This function will set new number of loaded months.
     *
     * @param {Number} newNumber
     */
    setNumberOfLoadedMonths(newNumber)
    {
        this.numberOfLoadedMonths = newNumber;
        this.datepicker.setOptions({ numberOfMonths: this.numberOfLoadedMonths });
    }

    /**
     * This function will add number to current loaded months.
     *
     * @param {Number} addNumber
     */
    addNumberOfLoadedMonths(addNumber)
    {
        this.numberOfLoadedMonths += addNumber;
        this.datepicker.setOptions({ numberOfMonths: this.numberOfLoadedMonths });
    }

    /**
     * This function will load more months and re-render the datepicker.
     *
     * @param {Number} count how many to load
     * @param {Boolean} previous true - load previous, false - next
     * @param {Number} scrollDatetime to which day scroll after rendering new months
     */
    loadMoreMonths(count, previous = false, scrollDatetime = undefined)
    {
        let newMonthsArray = [];
        this.addNumberOfLoadedMonths(count);

        if (!this.firstMonth) {
            this.firstMonth = new Date(
                $(this.datepicker.ui)
                    .find("[data-time]:first")
                    .data("time")
            );
        }

        if (previous) {
            this.firstMonth.setMonth(this.firstMonth.getMonth() - count);
        }

        if (this.firstMonth) {
            let tmpDateTime = this.datepicker.calendars[0].clone();
            let currentDate = new Date();

            for (
                let i = this.firstMonth.getMonth(); i < this.firstMonth.getMonth() + this.numberOfLoadedMonths; i++
            ) {
                let newMonth = tmpDateTime.clone();
                newMonth.dateInstance.setMonth(i);

                if (tmpDateTime.getMonth() + 1 < this.firstMonth.getMonth() + 1) {
                    newMonth.dateInstance.setFullYear(tmpDateTime.getFullYear() - 1);
                }

                // If the month is not before current one
                if (
                    newMonth.getMonth() >= currentDate.getMonth() &&
                    newMonth.getFullYear() >= currentDate.getFullYear()
                ) {
                    newMonthsArray.push(newMonth);
                }
            }
        }

        this.datepicker.calendars = newMonthsArray;
        if (scrollDatetime) {
            this.moreLoadedPrevTime = scrollDatetime;
        }
        this.reRenderDatepicker();
    }

    /**
     * Will resize and re-position the datepicker.
     *
     * @param {Element} $ui
     */
    resize($ui = undefined)
    {
        if (!$ui) {
            $ui = $(this.datepicker.ui);
        }

        let left = this.rootElement.offset().left + (this.rootElement.innerWidth() / 2 - $ui.innerWidth() / 2);
        let top = this.rootElement.offset().top + this.rootElement.innerHeight() + 5;
        $ui.css({
            left: left + "px",
            top: top + "px",
        });

        if (!$ui.hasClass("litepicker--small")) {
            // Position and alter results dimensions based on tablet, mobile or laptop
            if (Helper.isBigMobileOrLower()) {
                this.fitRespoModal($ui);
            } else if (Helper.isTabletOrLower()) {
                let top = this.rootElement.offset().top + this.rootElement.innerHeight() - 30;
                $ui.css({
                    top: top + "px",
                });
            } else {
                let top;
                if ($('[data-dim="search"]').is(':visible')) {
                    top = this.rootElement.position().top + this.rootElement.innerHeight() - 25;
                } else {
                    top = this.rootElement.innerHeight() - 25 - $(window).scrollTop();
                }


                $ui.css({
                    top: top + "px",
                    position: "fixed",
                    height: "",
                    width: "",
                });
            }
        } else {
            if (Helper.isBigMobileOrLower()) {
                $ui.css({
                    "z-index": 1007,
                });

                this.fitRespoModal($ui);
            } else if (Helper.isTabletOrLower()) {
                let top =
                    this.rootElement.offset().top + this.rootElement.innerHeight() - 30;
                $ui.css({
                    top: top + "px",
                    "z-index": 999,
                });
            } else {
                $ui.css({
                    "z-index": 999,
                });
            }
        }
    }

    /**
     * Will resize and reposition to fit respo modal.
     *
     * @param {Element} $ui
     * @param {Boolean} onlyTop if resize only top and height (used for respo modal hide transition)
     */
    fitRespoModal($ui = undefined, onlyTop = false)
    {
        $('body').css({'overflow' : 'hidden'});

        if (!$ui && !this.$ui) {
            $ui = this.$ui = $(this.datepicker.ui);
        }

        let top = this.startToggle.root.offset().top + 65 - $(window).scrollTop(); // 65 is height of toggle
        let height = 0;

        if (this.context.respoModal.$modal.data('fullscreenModal')) {
            height = $(window).height() - top;
        } else {
            height = $(window).height() - top - 24;
        }

        if (!onlyTop) {
            let width = this.context.respoModal.$modal
                .find("[data-search-actions]")
                .width();
            $ui.css({
                left: this.startToggle.root.offset().left + "px",
                height: height + "px", // 24 is padding for datepicker actions
                width: width + "px",
                top: top + "px",
                position: "fixed",
            });
        } else {
            this.$ui.css({
                top: top + "px",
                height: height, // 24 is padding for datepicker actions
            });
        }
    }

    /**
     * Will trigger after window resize.
     *
     * @see WindowResizeSubject
     */
    windowResizeCallback()
    {
        if (
            !this.startToggle.root.closest("[data-respo-modal]").length && this.initWidth !== $(window).width()
        ) {
            this.datepicker.hide();
            this.context.hideRespoModal();
        }

        this.resize();
    }

    /**
     * This function will return currently selected date formatted for searching and Rooms List
     *
     * @returns {Object}
     */
    getFormattedDate()
    {
        let startDate = this.formatDateForStoring(this.datepicker.getStartDate());
        let endDate = this.formatDateForStoring(this.datepicker.getEndDate());

        return {
            startDate: startDate,
            endDate: endDate,
        };
    }
}
